import axios from "axios";
import { useState } from "react";
import { Redirect, useHistory, useLocation } from "react-router-dom";

import { Button, Form, Image, message, Typography } from "antd";
import techPackIcon from "../../../assets/img/TechPack.svg";
import resolvedLogo from "../../../assets/img/pickpacknewlogo.svg";

import loginImage from "../../../assets/img/login-image.png";
import OtpInput from "../../../utils/otp/otp";

const { Text, Title } = Typography;
const currentYear = new Date().getFullYear();

const VerifyEmail = () => {
  const location = useLocation();
  const history = useHistory();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const email = location?.state?.email;

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const { data } = await axios.post("/auth/verifyOTP", {
        email,
        ...values,
      });

      setLoading(false);
      if (data?.statusCode === 200) {
        message.success(data?.result?.message || "Амжилттай");
        history.push("/change-password", {
          ...location?.state,
          resetToken: data?.result?.resetToken,
        });
      }
    } catch (error) {
      setLoading(false);
    }
  };

  if (!location?.state?.email) return <Redirect to="/forgot-password" />;

  return (
    <div className="fp-wrapper">
      {/* Left — cover image */}
      <div className="fp-cover">
        <div
          className="fp-cover-bg"
          style={{ backgroundImage: `url(${loginImage})` }}
        />
        <div className="fp-cover-overlay" />
      </div>

      {/* Right — form card */}
      <div className="fp-form-side">
        <div className="fp-form-main">
          <div className="fp-form-card">
            {/* Logo */}
            <div className="fp-logo-wrap">
              <Image
                src={resolvedLogo}
                className="fp-logo"
                alt="logo"
                preview={false}
              />
            </div>

            {/* Heading */}
            <div className="fp-heading">
              <Title level={3} className="fp-title">
                OTP код баталгаажуулах
              </Title>
              <Text className="fp-subtitle">
                <b>{email}</b> хаяг руу илгээсэн OTP кодыг оруулна уу.
              </Text>
            </div>

            {/* Form */}
            <Form
              form={form}
              name="otp_confirmation"
              className="fp-form"
              layout="vertical"
              labelAlign="left"
              onFinish={onFinish}
            >
              <Form.Item
                name="code"
                rules={[{ required: true, message: "OTP кодоо оруулна уу!" }]}
                hasFeedback
                style={{ display: "flex", justifyContent: "center" }}
              >
                <OtpInput
                  length={6}
                  onChange={(val) => form.setFieldValue("otp", val)}
                />
              </Form.Item>

              <Form.Item style={{ marginBottom: 0 }}>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  className="fp-submit-btn"
                  loading={loading}
                  block
                >
                  Баталгаажуулах
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
        {/* Footer */}
        <div className="fp-footer">
          <div className="fp-footer-brand">
            <span className="fp-powered">Powered by</span>
            <Image
              src={techPackIcon}
              preview={false}
              className="fp-techpack-logo"
              alt="TechPack"
            />
          </div>
          <span className="fp-copyright">
            © 2021-{currentYear} Зохиогчийн эрх хамгаалагдсан
          </span>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
